
import React from "react";
import { useForm } from 'react-hook-form';
import RFG from "../../libs/inputs/RFG";
import { Box, Typography, Button, Grid, Stack } from "@mui/material";
import MultiSelect from "../extra/MultiSelect";
import { FormHeroHeader, FormSectionCard, FormFooter, labelStyle } from "../extra/FormLayout";
import { BsBriefcaseFill, BsListTask } from "react-icons/bs";
import { generateFakeWorkData } from "../../libs/testDataGenerator";

export default function Form({
    title,
    users = [],
    clients = [],
    services = [],
    reviewers = [],
    tasks = [],
    defaultValues = {},
    onSubmit = (data) => { },
    onChange = (column, data) => { },
    back = () => { } }) {
    //let country = defaultValues?.country ? defaultValues.country : localCountryCode()
    const [open, setOpen] = React.useState(false)
    const { handleSubmit, control, setValue, watch, clearErrors, setError, formState: { errors }, } = useForm({ defaultValues: defaultValues, mode: "all" })
    const booleanFields = [
        { name: "verify", label: "Verified", watch: watch("verify") },
        { name: "active", label: "Active", watch: watch("active") },
    ];
    const seedData = (num, start_with = "Demo") => {
        return Array(10).fill().map((i, idx) => ({ id: (idx + 1), name: `${start_with} - ${(idx + 1)}` }))
    }

    const handleFillFakeData = () => {
        const fakeData = generateFakeWorkData(clients, services, users, reviewers);
        Object.entries(fakeData).forEach(([key, value]) => {
            setValue(key, value, { shouldValidate: true });
        });
        clearErrors();
    };

    const showAutoFill = process.env.REACT_APP_DEBUG !== "false" && process.env.REACT_APP_DEBUG !== "False" && process.env.REACT_APP_DEBUG !== "0";
    React.useEffect(() => {
        let idex = watch("service")
        onChange("service", idex)
    }, [watch("service")])
    React.useEffect(() => {
        let idex = watch("client")
        onChange("client", idex)
    }, [watch("client")])

    function getYearsUntil2025() {
        const currentYear = new Date().getFullYear();
        const years = [];
        for (let y = currentYear; y >= 2025; y--) {
            years.push({ name: y, id: y });
        }
        return years;
    }
    const years = getYearsUntil2025()
    return (
        <Box sx={{ py: 3, px: { xs: 1, md: 3 }, maxWidth: '1400px', mx: 'auto' }}>
            <FormHeroHeader
                icon={<BsBriefcaseFill size={26} />}
                title={title || "Work Setup"}
                subtitle="Configure work name, financial year assignment, client mapping, and service workflow."
                badgeText="Work Record"
            />
            <Box display="flex" justifyContent="flex-end" mb={2.5}>
                {showAutoFill && (
                    <Button
                        data-testid="btn-auto-fill-fake-work"
                        type="button"
                        variant="outlined"
                        onClick={handleFillFakeData}
                        sx={{
                            borderColor: '#10b981',
                            color: '#059669',
                            bgcolor: '#ecfdf5',
                            textTransform: 'none',
                            fontWeight: 700,
                            fontSize: '13px',
                            borderRadius: '20px',
                            px: 2.5, py: 0.8,
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1,
                            boxShadow: '0 2px 6px rgba(16, 185, 129, 0.15)',
                            '&:hover': { bgcolor: '#d1fae5', borderColor: '#059669', transform: 'translateY(-1px)' }
                        }}
                    >
                        ⚡ Auto-Fill Sample Data
                    </Button>
                )}
            </Box>
            <form
                onSubmit={handleSubmit((data) => {
                    console.log("data submit", data)
                    onSubmit(data)
                })}>
                <FormSectionCard
                    icon={<BsBriefcaseFill size={20} />}
                    title="Work Configuration"
                    subtitle="Define core parameters, client assignment, and reviewer roles"
                >
                    <Grid container spacing={3}>
                        <Grid size={{ xs: 12, md: 4 }}>

                            <RFG name="work_name" label="Work Name *" control={control} labelStyle={labelStyle} rules={{ required: true }}>
                                <input type="text" placeholder="e.g. Annual Audit Report" autoComplete="off" />
                            </RFG>
                            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                                <Box sx={{ flexGrow: 1 }}>
                                    <RFG name="financial_year" label="Financial Year *" control={control} labelStyle={labelStyle} rules={{
                                        required: true
                                    }}>
                                        <select>
                                            <option value="">Select FY</option>
                                            {years?.map((company) => <option key={company.id} value={company.id}>{company.name}</option>)}
                                        </select>
                                    </RFG>
                                </Box>
                                <Box sx={{ width: '130px' }}>
                                    <RFG name="weight" label="Priority Weight *" control={control} labelStyle={labelStyle} rules={{
                                        required: true
                                    }}>
                                        <select>
                                            <option value="">Weight</option>
                                            {[1, 2, 3, 4, 5]?.map((c) => <option key={c} value={c}>{c}</option>)}
                                        </select>
                                    </RFG>
                                </Box>
                            </Box>

                        </Grid>
                        <Grid size={{ xs: 12, md: 4 }}>

                            <RFG name="client" label="Client *" control={control} labelStyle={labelStyle} rules={{ required: true }}>
                                <select>
                                    <option value="">Select Client</option>
                                    {clients?.map((c) => <option key={c.id} value={c.id}>{c.business_name}</option>)}
                                </select>
                            </RFG>
                            <RFG name="work_manager" label="Work Manager *" control={control} labelStyle={labelStyle} rules={{ required: true }}>
                                <select>
                                    <option value="">Select Manager</option>
                                    {users?.map((c) => <option key={c.id} value={c.id}>{c.first_name || c.username}</option>)}
                                </select>
                            </RFG>

                        </Grid>
                        <Grid size={{ xs: 12, md: 4 }}>

                            <RFG name="service" label="Service *" control={control} labelStyle={labelStyle} rules={{ required: true }}>
                                <select>
                                    <option value="">Select Service</option>
                                    {services?.map((c) => <option key={c.id} value={c.id}>{c.service_name}</option>)}
                                </select>
                            </RFG>
                            <RFG name="reviewer" label="Reviewer(s)" control={control} labelStyle={labelStyle} rules={{}} error={errors.reviewer?.message}>
                                <MultiSelect
                                    isMultiSelect={true}
                                    options={reviewers.map((role) => ({ id: role.id, label: role.first_name || role.username }))}
                                    value={watch("reviewer")}
                                    defaultValue={defaultValues?.reviewer?.map(r => r) || ["SuperAdmin"]}
                                    onValueChange={(value) => {
                                        setValue("reviewer", value, { shouldValidate: true });
                                        if (value && value.length) clearErrors("role");
                                    }}
                                />
                            </RFG>

                        </Grid>
                    </Grid>
                </FormSectionCard>

                <Box display="flex" justifyContent="flex-end" sx={{ mt: 2, mb: 1 }}>
                    {showAutoFill && (
                        <Button
                            data-testid="btn-auto-fill-fake-bottom"
                            type="button"
                            variant="outlined"
                            onClick={handleFillFakeData}
                            sx={{
                                borderColor: '#10b981',
                                color: '#059669',
                                bgcolor: '#ecfdf5',
                                textTransform: 'none',
                                fontWeight: 700,
                                fontSize: '13px',
                                borderRadius: '20px',
                                px: 2.5, py: 0.8,
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1,
                                boxShadow: '0 2px 6px rgba(16, 185, 129, 0.15)',
                                '&:hover': { bgcolor: '#d1fae5', borderColor: '#059669', transform: 'translateY(-1px)' }
                            }}
                        >
                            ⚡ Auto-Fill Sample Data
                        </Button>
                    )}
                </Box>

                <FormFooter 
                    onCancel={back} 
                    backText="Back" 
                    submitText={defaultValues?.id ? "Update Work" : "Save Work"} 
                    isEdit={!!defaultValues?.id}
                    backTestId="back-work-btn" 
                    saveTestId="save-work-btn" 
                />
            </form>

            <Box sx={{ mt: 4 }}>
                <FormSectionCard
                    icon={<BsListTask size={20} />}
                    title={`Associated Workflow Tasks (${tasks?.[0]?.service_name || 'Selected Service'})`}
                    subtitle="Tasks automatically generated and monitored from the selected service template"
                    sx={{ mb: 0 }}
                >
                    <Grid container spacing={2}>
                        {tasks?.map((task, idx) => (
                            <Grid key={idx} size={{ xs: 12, sm: 6, md: 4 }}>
                                <Box sx={{
                                    fontSize: 13,
                                    background: 'linear-gradient(135deg, #f8fafc 0%, #eff6ff 100%)',
                                    border: '1px solid #dbeafe',
                                    borderRadius: '10px',
                                    p: 2,
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1.5,
                                    boxShadow: '0 2px 4px rgba(37, 99, 235, 0.04)',
                                    transition: 'all 0.2s',
                                    '&:hover': { borderColor: '#93c5fd', transform: 'translateY(-1px)' }
                                }}>
                                    <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#2563eb', flexShrink: 0 }} />
                                    <Typography fontWeight={600} color="#1e293b">{task?.task_name}</Typography>
                                </Box>
                            </Grid>
                        ))}
                        {(!tasks || tasks.length === 0) && (
                            <Grid size={{ xs: 12 }}>
                                <Box sx={{ textAlign: 'center', py: 4, bgcolor: '#f8fafc', borderRadius: '12px', border: '1px dashed #cbd5e1' }}>
                                    <Typography fontSize={14} color="#64748b" fontWeight={500}>No tasks available for this service yet. Select a service above to preview tasks.</Typography>
                                </Box>
                            </Grid>
                        )}
                    </Grid>
                </FormSectionCard>
            </Box>
        </Box>
    );
}